import React from "react";
import { connect } from "react-redux";
import { LocalizationProvider } from "@material-ui/pickers";
import DateFnsAdapter from "@material-ui/pickers/adapter/date-fns";

import frLocale from "date-fns/locale/fr";
import enLocale from "date-fns/locale/en-CA";

const localeMap = {
    en: enLocale,
    fr: frLocale,
};

export const Provider = (props) => (
    <LocalizationProvider locale={localeMap[props.lang]} dateAdapter={DateFnsAdapter}>
        {props.children}
    </LocalizationProvider>
);

// This function will map the current redux state to the props for the component that it is "connected" to.
// When the state of the redux store changes, this function will be called, if the props that come out of
// this function are different, then the component that is wrapped is re-rendered.
function mapStateToProps(state) {
    return {
        lang: state.domain.locale.lang,
    };
}

export default connect(mapStateToProps)(Provider);
